/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import { PaletteColor, Theme, capitalize } from '@quillbot/design-system';
import { UNITS } from './units';

export type Edges = 'topLeft' | 'topRight' | 'bottomRight' | 'bottomLeft';
export type Vertices = 'top' | 'right' | 'bottom' | 'left';
export type VerticesValues = Partial<Record<Vertices, string>>;
export type EdgeValues = Partial<Record<Vertices, string>>;
export type BorderProperties = {
  /** width of border in 'pixel' */
  width?: string;
  /** style of border */
  style?: string;
  /** color of the border */
  color?: string | ((theme: Theme) => string);
};

export const unitPX = (value: any) => `${parseFloat(value)}px`;

export const getDividerColor = (theme: Theme) => theme.palette.divider;
export const getTextColor = (color: keyof Theme['palette']['text']) => (theme: Theme) =>
  theme.palette.text[color];

export const getPrimaryColor = (theme: Theme) => theme.palette.primary.main;

export const createBorder = (vertices: Vertices[], properties?: BorderProperties) => {
  const out: any = {};

  const color = properties?.color || ((theme: Theme) => theme.palette.divider);

  vertices.forEach((vertex) => {
    out[`border${capitalize(vertex)}Width`] = unitPX(properties?.width || UNITS['1px']);
    out[`border${capitalize(vertex)}Style`] = properties?.style || 'solid';
    out[`border${capitalize(vertex)}Color`] = color;
  });

  return out;
};

export const createBorderRadius = (edges: Edges[], radius: string | EdgeValues) => {
  const out: any = {};

  if (typeof radius === 'string') {
    edges.forEach((edge) => {
      if (typeof radius === 'string') {
        out[`border${capitalize(edge)}Radius`] = radius;
      }
    });
  } else {
    const edgeRadius = radius as EdgeValues;
    for (const e in edgeRadius) {
      const edge = e as keyof typeof edgeRadius;
      if (
        edge in edgeRadius &&
        typeof edgeRadius[edge] !== 'undefined' &&
        Object.prototype.hasOwnProperty.call(edgeRadius, edge)
      ) {
        out[`border${capitalize(edge)}Radius`] = edgeRadius[edge];
      }
    }
  }

  return out;
};

export const createMargin = (vertices: Vertices[] | VerticesValues, width?: string) => {
  let out: any;

  if (!Array.isArray(vertices)) {
    out = {};
    const verticesValues = vertices as VerticesValues;
    for (const e in verticesValues) {
      const vertex = e as keyof typeof verticesValues;
      if (
        vertex in verticesValues &&
        typeof verticesValues[vertex] !== 'undefined' &&
        Object.prototype.hasOwnProperty.call(verticesValues, vertex)
      ) {
        out[`margin${capitalize(vertex)}`] = verticesValues[vertex];
      }
    }
  } else if (typeof width === 'string') {
    out = {};

    const verticesNames = vertices as Vertices[];
    verticesNames.forEach((vertex) => {
      out[`margin${capitalize(vertex)}`] = width;
    });
  }

  return out;
};

export const createPadding = (vertices: Vertices[] | VerticesValues, width?: string) => {
  let out: any;
  if (!Array.isArray(vertices)) {
    out = {};

    const verticesValues = vertices as VerticesValues;
    for (const e in verticesValues) {
      const vertex = e as keyof typeof verticesValues;
      if (
        vertex in verticesValues &&
        typeof verticesValues[vertex] !== 'undefined' &&
        Object.prototype.hasOwnProperty.call(verticesValues, vertex)
      ) {
        out[`padding${capitalize(vertex)}`] = verticesValues[vertex];
      }
    }
  } else if (typeof width === 'string') {
    out = {};

    const verticesNames = vertices as Vertices[];
    verticesNames.forEach((vertex) => {
      out[`padding${capitalize(vertex)}`] = width;
    });
  }
  return out;
};
